'use client';

import _slicedToArray from "/builds/fathomio/NuaLang/nualang.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["actions", "children", "defaultValue", "name", "onChange", "value"];
import * as React from 'react';
import FormGroup from '../FormGroup';
import useForkRef from '../utils/useForkRef';
import useControlled from '../utils/useControlled';
import RadioGroupContext from './RadioGroupContext';
import useId from '../utils/useId';
import { jsx as _jsx } from "react/jsx-runtime";
var RadioGroup = /*#__PURE__*/React.forwardRef(function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      defaultValue = props.defaultValue,
      nameProp = props.name,
      _onChange = props.onChange,
      valueProp = props.value,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  var rootRef = React.useRef(null);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'RadioGroup'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValueState = _useControlled2[1];

  React.useImperativeHandle(actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = useForkRef(ref, rootRef);
  var name = useId(nameProp);
  var contextValue = React.useMemo(function () {
    return {
      name: name,
      onChange: function onChange(event) {
        setValueState(event.target.value);

        if (_onChange) {
          _onChange(event, event.target.value);
        }
      },
      value: value
    };
  }, [name, _onChange, setValueState, value]);
  return /*#__PURE__*/_jsx(RadioGroupContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(FormGroup, _extends({
      role: "radiogroup",
      ref: handleRef
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default RadioGroup;